import type { AxiosResponse } from "axios";
import { BASE_URL, httpClient } from "../config/develop-config";

const baseUrl = `${BASE_URL}/crm/customer-tier`;

export interface CustomerTierSummaryItem {
  customerTierId: string;
  customerCompanyId: number;
  customerNo: string;
  customerName: string;
  customerProvince: string;
  customerZone: string;
  currentTierName: string | null;
  currentTierColor: string | null;
  earnedTierName: string | null;
  earnedTierColor: string | null;
  isPendingReview: boolean;
  accruedTotal: number;
  accruedAmount: number;
  accruedQuantity: number;
  isUpdateNav: boolean;
  tierChangedAt: string | null;
  historyCount: number;
  updatedAt: string;
}

const getCustomerTierOverview = async (params: { company: string }) => {
  return await httpClient
    .get(`${baseUrl}/get-customer-tier-overview`, { params })
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};

const getCustomerTierSummary = async (
  params: { 
    company: string 
    tierLevelId? : string
    customerZone? : string
    search?: string
    status?: string
    isUpdatedNav? : boolean
    sortBy : string
    sortOrder : string
    page: number
    take: number
  }
) => {
  return await httpClient
    .get(`${baseUrl}/get-customer-tier-summary`, { params })
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};

export { getCustomerTierOverview, getCustomerTierSummary };